import {
  SketchEntitiesTransformCommand,
  canShowSketchPropertySection,
  registerPropertyManagerSection,
} from '@/core';
import SketchMirrorEntitiesPropertySection from '@/components/editor/property-manager/entities-transform/SketchMirrorEntitiesPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-mirror-entities',
  title: '镜向实体',
  order: 21,
  component: SketchMirrorEntitiesPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.sketchEntitiesTransformState?.canConfirm !== true,
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.activeCommand === SketchEntitiesTransformCommand.Mirror
        && context.sketchEntitiesTransformState?.active === true,
    );
  },
  onConfirm: (context) => {
    void context.confirmSketchEntitiesTransform?.();
  },
  onCancel: (context) => {
    context.cancelSketchEntitiesTransform?.();
  },
});
